import { observer } from 'mobx-react';
import React from 'react';

import { useContext } from '../../../../hooks/useContext';
import { AccountDetailStore } from '../stores/AccountDetailStore';
import { useActions } from './hook/useActions';
import { RegisterPage } from './register/index';

export const FirstReserverAccountEditPage = observer(() => {
  const store = useContext(AccountDetailStore.Context);
  const { doFix, fixStatus } = useActions(store, new URL(window.location.href));

  return <RegisterPage store={store} onCommit={() => doFix()} disabled={fixStatus.running} />;
});
